module.exports = __webpack_public_path__ + "static/img/loading.3016b11.gif";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/loading.gif
// module id = jjqj
// module chunks = 0